import 'stylesheets/global.scss';
import 'stylesheets/components/list.scss';

import React, {Component,PropTypes} from 'react';
import { Link } from 'react-router';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { store } from 'app/store';
import { Header, Page, PageMain, PageLeft } from 'routes/app/components';
import { LicensePlatesContainer } from './LicensePlates';

export class Settings extends Component {

    static propTypes = {
        preferredLicensePlate: PropTypes.string,
        routeParams: PropTypes.shape({
            page: PropTypes.oneOf(['license-plate'])
        })
    };

    getLicensePlate() {
        return this.props.preferredLicensePlate || '(None)';
    }

    rightArrow() {
        return <span className="secondary-content"><i className="material-icons">keyboard_arrow_right</i></span>;
    }

    pageIdToTitle(pageId) {
        return {
            'license-plate': 'Preferred license plate'
        }[pageId];
    }

    pageIdToComponent(pageId) {
        return {
            'license-plate': <LicensePlatesContainer />
        }[pageId];
    }

    render() {

        let pageId = this.props.routeParams.page || 'license-plate';

        let className = {
            'collection-item': true
        };

        return (
            <section>
                <Header>
                    <h1>Settings</h1>
                </Header>

                <Page>
                    <PageLeft>
                        <ul className="list-bordered">
                            <li>
                            </li>
                            <li>
                                <Link to="/settings/license-plate"
                                      className={classNames(className, {active: pageId === 'license-plate'})}
                                      activeClassName="active">License plate {this.rightArrow()}</Link>
                            </li>
                        </ul>
                    </PageLeft>
                    <PageMain title={this.pageIdToTitle(pageId)} sideNav>
                        {this.pageIdToComponent(pageId)}
                    </PageMain>
                </Page>

            </section>
        );
    }

}

function mapStateToProps(state) {
    return {
        preferredLicensePlate: state.get('profile').get('licensePlate')
    };
}

export const SettingsContainer = connect(mapStateToProps)(Settings);
